import { FC, ReactNode, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { IPOAccount, IPOButton, IPOMessage, IPOTag } from '@hylaa-npm/ipod';
import * as router from '@/routers/routePathKey';
import PageContainer, { IPageRef } from '@/components/Page';
import { ISearchTool, IValueProps, PSearchTool, SearchEnum } from '@/components/PSearchTool';
import { PUploadFn } from '@/components/PUpload';
import Empty from '@/components/Empty';
import CreateMember from './components/CreateMember';
// import MemberDetail from './components/Detail/index';

import { BASEURL } from '@/apis';
import { getTags } from '@/apis/tags';
import {
	accountAddTag,
	addAccount,
	addOfficial,
	getOfficialAccounts,
	getTmpAccounts,
	IOfficialAccountParams,
} from '@/apis/account';
import { getTmpAccountFromClients, sendOfficialToClient } from '@/apis/sync';

import { ITmpAccount } from './member';

import { MemberContentTitleWrap, MemberWrap } from './style';
import { useHistory } from 'react-router-dom';

const Member: FC<{}> = () => {
	const { t } = useTranslation();
	let history = useHistory();
	const pageRef = useRef<IPageRef>();
	const clients = useSelector((state: { clients: ISplitEnd[] }) => state.clients);

	const cardWidth = 244;
	const cardHeight = 170;
	const cardTop = 18;
	const cardLeft = 18;

	const [members, setMembers] = useState<IPOAccount.IMember[]>([]);
	const [tmpMembers, setTmpMembers] = useState<ITmpAccount[]>([]);
	const [tmpMember, setTmpMember] = useState<ITmpAccount | undefined>();
	const [tmpAccount, setTmpAccount] = useState<IPOAccount.IMember | undefined>();
	const [majors, setMajors] = useState<IPOTag.ITag[]>([]);
	const [teams, setTeams] = useState<IPOTag.ITag[]>([]);
	const [avatar, setAvatar] = useState<string>('');

	const [active, setActive] = useState<'official' | 'tmp'>('official');
	const [isShowAdd, setIsShowAdd] = useState<boolean>(false);

	const [total, setTotal] = useState<number>(0);
	const [pagination, setPagination] = useState<IPagination>({ take: 10, offset: 0 });
	const [officialSearch, setOfficialSearch] = useState<IOfficialAccountParams>({
		name: '',
		team: '',
		ability: '',
	});
	const [tmpSearch, setTmpSearch] = useState<string>('');

	useEffect(() => {
		if (pageRef.current) {
			const take = pageRef.current?.pageSize;
			setPagination({ take, offset: 0 });
		}
	}, [pageRef]);
	/**
	 * 当tab，搜索，分页存在变化的时候请求列表
	 */
	useEffect(() => {
		if (active === 'official') {
			getOfficialAccountList(officialSearch, pagination);
		} else {
			getTmpAccountList(tmpSearch, pagination);
		}
	}, [JSON.stringify(officialSearch), JSON.stringify(pagination), active, tmpSearch]);

	useEffect(() => {
		getTagList(1); // 专业
		getTagList(2); // 团队
	}, []);

	/**
	 * 获取标准库列表
	 * @param param
	 * @param pagination
	 */
	const getOfficialAccountList: (param: IOfficialAccountParams, pagination: IPagination) => void = (
		param,
		pagination,
	) => {
		if (pagination.take > 0) {
			getOfficialAccounts(param, pagination).then((res) => {
				const tmps: IPOAccount.IMember[] = [];
				res.list.forEach((item) => {
					let tagAbilityList: IPOTag.ITag[] = [];
					let tagTeamList: IPOTag.ITag[] = [];
					let tagTeamsIds: string[] = [];
					let tagAbilityIds: string[] = [];
					item.ability.forEach((tag) => {
						if (!tagAbilityIds.includes(tag.id)) {
							tagAbilityIds.push(tag.id);
							tagAbilityList.push(tag);
						}
					});
					item.teams.forEach((tag) => {
						if (!tagTeamsIds.includes(tag.id)) {
							tagTeamsIds.push(tag.id);
							tagTeamList.push(tag);
						}
					});
					const account: IPOAccount.IMember = {
						...item,
						teams: tagTeamList,
						ability: tagAbilityList,
					};
					tmps.push(account);
				});
				setMembers([...tmps]);
				setTotal(res.pagination.size ? res.pagination.size : res.list.length);
			});
		}
	};
	/**
	 * 临时成员列表
	 * @param param
	 * @param pagination
	 */
	const getTmpAccountList: (param: string, pagination: IPagination) => void = (
		param,
		pagination,
	) => {
		if (pagination.take > 0) {
			getTmpAccounts(param, pagination).then((res) => {
				const tmps: IPOAccount.IMember[] = [];
				res.list.forEach((item) => {
					let tagList: IPOTag.ITag[] = [];
					let tagTmpList: IPOTag.ITag[] = [];
					let tagIds: string[] = [];
					let tagTmpIds: string[] = [];

					item.teamMembers?.forEach((teamMember) => {
						if (teamMember.tags) {
							teamMember.tags.forEach((v) => {
								if (!tagIds.includes(v.id)) {
									tagList.push(v);
									tagIds.push(v.id);
								}
							});
						}
						if (teamMember.tmpTags) {
							teamMember.tmpTags.forEach((v) => {
								if (!tagTmpIds.includes(v.id)) {
									tagTmpList.push(v);
									tagTmpIds.push(v.id);
								}
							});
						}
					});

					let allTag: IPOTag.ITag[] = [...tagList, ...tagTmpList];
					let teams = allTag.filter((tag) => ((tag?.type as unknown) as 1 | 2) === 2);
					let ability = allTag.filter((tag) => ((tag?.type as unknown) as 1 | 2) === 1);

					const account: IPOAccount.IMember = {
						...item,
						teams,
						ability,
					};
					tmps.push(account);
				});
				setMembers([...tmps]);
				setTmpMembers([...res.list]);
				setTotal(res.pagination.size ? res.pagination.size : res.list.length);
			});
		}
	};
	/**
	 * 标签列表
	 * @param type
	 */
	const getTagList: (type: IPOTag.TagEnum) => void = (type) => {
		getTags(type, '', { offset: 0, take: 500 }).then((res) => {
			if (type === IPOTag.TagEnum.MAJOR) {
				setMajors(res.list);
			} else {
				setTeams(res.list);
			}
		});
	};
	/**
	 * 跳转人员详情
	 * @param account
	 */
	const getAccountDetail: (account: IPOAccount.IMember) => void = (account) => {
		if (active === 'official') {
			history.push(router.KEY_PATH_STANDARD_LIBRARY_DETAIL, {
				id: account.id,
				accountId: account.accountId,
			});
		}
	};
	/**
	 * 添加成员 ==》第一步：添加为成员得到accountId，
	 * @param info
	 * @returns
	 */
	const handleAddAccount: (info: IPOAccount.IAddAccount) => Promise<string> = (info) => {
		return new Promise((res) => {
			addAccount({ ...info, avatar: avatar }).then((account) => {
				setTmpAccount(() => {
					return {
						...account,
						teams: [],
						ability: [],
						accountId: account.id,
						avatar: avatar,
					};
				});
				res(account.id);
			});
		});
	};
	/**
	 * 添加成员  ==》第二步，添加为标准库成员，
	 * @param accountId
	 * @returns
	 */
	const handleAddMember: (accountId: string) => Promise<void> = (accountId) => {
		return new Promise<void>((res) => {
			addOfficial(accountId).then((account) => {
				console.log(tmpAccount, 'oooo', account);
				setTmpAccount((oldValue) => {
					if (oldValue) {
						oldValue.accountId = account.accountId;
						oldValue.id = account.id;
						setMembers([oldValue, ...members]);
					}
					return undefined;
				});
				setAvatar('');
				res();
			});
		});
	};
	/**
	 * 添加成员  ==》第三步，为成员accountId添加标签
	 * @param tagId
	 * @param accountId
	 * @returns
	 */
	const handleAddTag: (tagId: string, accountId: string) => Promise<void> = (tagId, accountId) => {
		return new Promise((res) => {
			accountAddTag(accountId, tagId).then((result) => {
				res();
				setMembers((oldValue) => {
					oldValue.forEach((item) => {
						if (item.accountId === result.id) {
							item.teams = result.tags.filter((tag) => tag.type === IPOTag.TagEnum.TEAM);
							item.ability = result.tags.filter((tag) => tag.type === IPOTag.TagEnum.MAJOR);
							item.accountId = result.id;
						}
					});
					return [...oldValue];
				});
			});
		});
	};
	/**
	 * 临时成员添加为标准库成员  ---> 实时更新，移除当前列表
	 * @param id
	 */
	const handleTmpToOfficial: (id: string) => void = (id) => {
		let copyMembers = members.filter((item) => {
			return item.id !== id;
		});
		setMembers([...copyMembers]);
		setTmpMember(undefined);
	};
	/**
	 * 设置搜索栏 ===》根据不同的tab显示不同的状态
	 * @returns
	 */
	const getSearchEle: () => ReactNode = () => {
		const tmpTools = [{ key: 'name', placeholder: t('common.plInput'), type: SearchEnum.INPUT }];
		const officialTools = [
			{ key: 'name', placeholder: t('common.plInput'), type: SearchEnum.INPUT },
			{
				key: 'team',
				placeholder: t('common.plSelect'),
				type: SearchEnum.SELECT,
				defaultValue: '',
				selectData: {
					seleceKey: 'id',
					selectLabel: 'name',
					selectTree: [
						{ name: t('common.allTeam'), id: '' },
						...((teams as unknown) as { [key: string]: string }[]),
					],
					isSearch: true,
				},
			},
			{
				key: 'ability',
				placeholder: t('common.plSelect'),
				type: SearchEnum.SELECT,
				defaultValue: '',
				selectData: {
					seleceKey: 'id',
					selectLabel: 'name',
					selectTree: [
						{ name: t('common.allMajor'), id: '' },
						...((majors as unknown) as { [key: string]: string }[]),
					],
					isSearch: true,
				},
			},
		];
		let tools: ISearchTool[] = [];
		active === 'official' && (tools = [...officialTools]);
		active === 'tmp' && (tools = [...tmpTools]);
		const handleSearch: (value: IValueProps) => void = (value) => {
			if (active === 'official') {
				setOfficialSearch((value as unknown) as IOfficialAccountParams);
			} else {
				setTmpSearch((value.name as unknown) as string);
			}
			setPagination({ ...pagination, offset: 0 });
		};
		return <PSearchTool tools={tools} handleSearch={(value: IValueProps) => handleSearch(value)} />;
	};
	/**
	 * 列表的显示
	 * @returns
	 */
	const getContentEle: () => ReactNode = () => {
		const getEmptyType: () => 'search' | 'nodata' = () => {
			if (
				(active === 'official' &&
					(officialSearch.ability || officialSearch.name || officialSearch.team)) ||
				(active === 'tmp' && tmpSearch)
			) {
				return 'search';
			} else {
				return 'nodata';
			}
		};
		return (
			<>
				{members.length > 0 ? (
					<MemberWrap
						cardWidth={cardWidth}
						cardHeight={cardHeight}
						cardTop={cardTop}
						cardLeft={cardLeft}>
						{members.map((member: IPOAccount.IMember) => {
							const getMemberCardProps = {
								baseUrl: BASEURL,
								userInfo: member,
								buttonNode: active === 'tmp' && (
									<IPOButton
										type="ghost"
										onClick={() =>
											setTmpMember(tmpMembers.filter((item) => item.id === member.id)[0])
										}>
										{t('standard.add')}
									</IPOButton>
								),
							};
							return (
								<div
									onClick={() => getAccountDetail(member)}
									className="member-wrap"
									key={member.id}>
									<IPOAccount.MemberCard {...getMemberCardProps} />
								</div>
							);
						})}
					</MemberWrap>
				) : (
					<Empty type={getEmptyType()} tips={getEmptyType() === 'nodata' ? '暂无数据' : ''} />
				)}
			</>
		);
	};
	const getContentTitleEle: () => ReactNode = () => {
		const asyncTmpFromClient: () => void = () => {
			const promises: Promise<void>[] = [];
			clients.forEach((client) => {
				if (client.connectState === 1) {
					promises.push(getTmpAccountFromClients(client.id));
				}
			});

			Promise.allSettled(promises).then((res) => {
				let fulfilleds: number = 0;
				let rejecteds: number = 0;
				res.forEach((item) => {
					item.status === 'fulfilled' && fulfilleds++;
					item.status === 'rejected' && rejecteds++;
				});
				if (rejecteds !== 0) {
					IPOMessage.error(`共有${res.length}个同步任务， 其中${rejecteds}个任务启动失败`);
				} else {
					IPOMessage.success(t('common.synchronizationSucceeded'));
				}
			});
		};

		const asyncOfficialToClient: () => void = () => {
			const promises: Promise<void>[] = [];
			clients.forEach((client) => {
				if (client.connectState === 1) {
					promises.push(sendOfficialToClient(client.id));
				}
			});
			console.log(clients);

			Promise.allSettled(promises).then((res) => {
				let fulfilleds: number = 0;
				let rejecteds: number = 0;
				res.forEach((item) => {
					item.status === 'fulfilled' && fulfilleds++;
					item.status === 'rejected' && rejecteds++;
				});
				if (rejecteds !== 0) {
					IPOMessage.error(`共有${res.length}个同步任务， 其中${rejecteds}个任务启动失败`);
				} else {
					IPOMessage.success(t('common.synchronizationSucceeded'));
				}
			});
		};
		return (
			<MemberContentTitleWrap>
				<div className="left">
					<div
						onClick={() => setActive('official')}
						className={`${active === 'official' ? 'active-title' : ''} title`}>
						{t('standard.memberList')}
					</div>
					<div
						onClick={() => setActive('tmp')}
						className={`${active === 'tmp' ? 'active-title' : ''} title`}>
						{t('standard.waitingToAddMembers')}
					</div>
				</div>
				<div className="right">
					{active === 'official' && (
						<div>
							<IPOButton onClick={() => setIsShowAdd(true)}>
								{t('standard.addIbraryMember')}
							</IPOButton>
							<IPOButton onClick={() => asyncOfficialToClient()}>
								{t('standard.synchronization')}
							</IPOButton>
						</div>
					)}
					{active === 'tmp' && (
						<IPOButton onClick={() => asyncTmpFromClient()}>
							{t('standard.synchronization')}
						</IPOButton>
					)}
				</div>
			</MemberContentTitleWrap>
		);
	};
	return (
		<>
			<PageContainer
				pageRef={pageRef}
				pageTitle={t('standard.title')}
				searchEle={getSearchEle()}
				contentTitle={getContentTitleEle()}
				contentEle={getContentEle()}
				pagi={{
					total,
					handlePageChange: (offset) => setPagination({ ...pagination, ...{ offset } }),
					pageType: 'card',
					cardInfo: {
						width: cardWidth,
						height: cardHeight,
						rowGap: cardLeft,
						colGap: cardTop,
					},
				}}
			/>
			{tmpMember && (
				<CreateMember
					memberInfo={tmpMember}
					handleCancel={() => setTmpMember(undefined)}
					handleOk={(id) => handleTmpToOfficial(id)}
					majorTag={majors}
					teamTag={teams}
				/>
			)}
			{isShowAdd && (
				<IPOAccount.AddMember
					uploadEle={<PUploadFn.User avatar={avatar} changeAvatar={(id) => setAvatar(id)} />}
					majorTags={majors}
					teamTags={teams}
					isShowAdd={isShowAdd}
					handleChange={() => {
						setIsShowAdd(false);
						setAvatar('');
					}}
					handleAddAccount={(info) => handleAddAccount(info)}
					handleAddTag={(tagId, accountId) => handleAddTag(tagId, accountId)}
					handleAddMember={(accountId) => handleAddMember(accountId)}
				/>
			)}
		</>
	);
};

export default Member;
